export default {
  install: function (Vue, store, router) {
    if (this.installed) {
      return
    }

    this.installed = true

    // 重送失敗時要回報「重送自己的結果」,不能丟回原本那個 403。
    //
    // session 被換掉時(逾時、CAS 重新認證、節點切換),重送帶著新 token 會通過 CSRF,
    // 但新 session 沒有登入狀態,於是拿到的是 401。丟回原始的 403 會把這個 401 蓋掉,
    // 而 errorHandler 沒有 403 handler、會掉進 500 handler 把客人送去 /500 ——
    // 客人因此沒機會走 401 的重新登入,只能自己另開頁簽。
    //
    // 網路層錯誤沒有 data(沒有 status 可判讀),仍退回原始回應,
    // 免得 errorHandler 取 response.data.status 時炸掉。
    var rejectWithRetryOutcome = function (retryOutcome, originalResponse) {
      return Promise.reject(retryOutcome && retryOutcome.data ? retryOutcome : originalResponse)
    }

    var retryCsrf = function (error) {
      error.config.headers[Vue.axios.defaults.xsrfHeaderName] = error.data.csrfToken

      return Vue.axios(error.config)
        .then((retryResponse) => {
          return Promise.resolve(retryResponse)
        }).catch((retryError) => {
          return rejectWithRetryOutcome(retryError, error)
        })
    }

    // CSRF token 與伺服器 session 不同步時,錯誤回應會夾帶「當前 session 的正確 token」
    // (AjaxErrorAttributes 無條件塞 csrfToken),補上去重送一次就會通過。
    //
    // 第一個條件是原本就有的判斷,保留:它最精準,且若哪天後端打開
    // server.error.include-exception,它就會直接生效。
    //
    // 但它單獨不夠用,原因有二:
    //   1. 實際發生的是 InvalidCsrfTokenException —— CAS 認證成功會換 session 並輪替 CSRF token,
    //      瀏覽器手上的 cookie 沒跟上就是 Invalid,不在這個條件內 → 不重試 → 客人被導去 /500。
    //   2. exception 欄位要 server.error.include-exception=true 才會輸出,而各環境都沒設定
    //      (Spring Boot 2.3 起改為預設不輸出),所以目前這個條件不會成立。
    // 故補上「403 且回應帶得回 csrfToken」作為後備:Missing / Invalid 兩種都涵蓋,也不依賴 exception 欄位。
    // 非 CSRF 的真正 403 頂多多送一次(_retry 只允許一次)後照樣 reject,對外行為不變。
    var isCsrfTokenFailure = function (response) {
      if (response.data.exception === 'org.springframework.security.web.csrf.MissingCsrfTokenException') {
        return true
      }

      return response.data.status === 403 && !!response.data.csrfToken
    }

    Vue.axios.interceptors.request.use(
      function (config) {
        let showSpinner = 'showSpinner' in config ? config.showSpinner : true

        if (showSpinner) {
          Vue.spinner.spin(document.body)
        }

        return config
      },
      function (error) {
        return Promise.reject(error)
      }
    )

    Vue.axios.interceptors.response.use(
      function (response) {
        let showSpinner = 'showSpinner' in response.config ? response.config.showSpinner : true

        if (showSpinner) {
          Vue.spinner.stop()
        }

        if (response.request.responseType === 'text') { // newHeader
          return response
        }

        if (response.data.status === 200) {
          return response
        } else {
          if (isCsrfTokenFailure(response)) {
            if (response.config._retry) { // retry only once
              return Promise.reject(response)
            }

            response.config._retry = true

            return retryCsrf(response).then(
              function (retryResponse) {
                if (retryResponse.data.status === 200) {
                  return Promise.resolve(retryResponse)
                } else {
                  return Promise.reject(retryResponse)
                }
              },
              function (retryError) {
                return rejectWithRetryOutcome(retryError, response)
              }
            )
          } else {
            return Promise.reject(response)
          }
        }
      },
      function (error) {
        if (Vue.axios.isCancel(error)) {
          return Promise.reject(error)
        } else {
          let showSpinner = 'showSpinner' in error.config ? error.config.showSpinner : true

          if (showSpinner) {
            Vue.spinner.stop()
          }

          return Promise.reject(error.response)
        }
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/configs/interceptors/index.js